import React from "react";
import { Link } from "react-router-dom";
import { Nav } from "../../../../components/ui";
import { SEARCH_PATH } from "../../../../utils/searchUtils";

import Notifications from "./Notifications";
import UserActions from "./UserActions";

export default () => (
  <Nav navbar className="border-left flex-row">
    <li className="main-navbar-mobile-search">
      <Link
        to={SEARCH_PATH}
        className="main-navbar-mobile-search__link"
        aria-label="Search"
      >
        <i className="material-icons">search</i>
      </Link>
    </li>
    <Notifications />
    <UserActions />
  </Nav>
);
